import Header from "../components/Header";
import styles from "./LegalPage.module.css";

export default function Datenschutz() {
  return (
    <div className={styles.legalPage}>
      <Header />
      <div className={styles.content}>
        <h1>Daten&shy;schutz&shy;erklä&shy;rung</h1>

        <section>
          <p>
            Ihr Vertrauen in uns und damit der Datenschutz Ihrer
            personenbezogenen Daten haben einen besonders hohen Stellenwert für
            stahlfaktor: Melanie Brücher-Kümmel und ihre Geschäftsführung.
          </p>
          <p>
            stahlfaktor möchte Sie in dieser Datenschutzerklärung über Art,
            Umfang und Zweck der von uns erhobenen, genutzten und verarbeiteten
            personenbezogenen Daten informieren. Personenbezogene Daten sind
            alle Daten, die auf Sie persönlich beziehbar sind, z. B. Name,
            Adresse, E-Mail-Adressen, IP-Adressen, Nutzungsverhalten. Weiterhin
            werden betroffene Personen mittels dieser Datenschutzerklärung über
            die ihnen zustehenden Rechte aufgeklärt.
          </p>
          <p>
            Bei bloßer Nutzung dieser Website, ohne Übermittlung anderweitiger
            Informationen, werden nur personenbezogene Daten erhoben, die Ihr
            Browser an unseren Server übermittelt. Im Einzelnen werden die
            folgenden Daten erhoben, die technisch erforderlich sind, um Ihnen
            die Website anzuzeigen und die Stabilität und Sicherheit zu
            gewährleisten (Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO):
          </p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit der Anfrage</li>
            <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
            <li>Inhalt der Anforderung (konkrete Seite)</li>
            <li>
              Zugriffsstatus/HTTP-Statuscode jeweils übertragene Datenmenge
            </li>
            <li>Website, von der die Anforderung kommt (Referrer)</li>
            <li>Browser-Typ</li>
            <li>Betriebssystem und dessen Oberfläche</li>
            <li>Sprache und Version der Browsersoftware</li>
          </ul>
          <p>
            Sofern eine betroffene Person besondere Services von stahlfaktor
            über unsere Internetseite in Anspruch nehmen möchte, könnte jedoch
            eine Verarbeitung personenbezogener Daten erforderlich werden. Ist
            die Verarbeitung personenbezogener Daten erforderlich und besteht
            für eine solche Verarbeitung keine gesetzliche Grundlage, holen wir
            generell eine Einwilligung der betroffenen Person ein.
          </p>
        </section>

        <section>
          <h2>Kontaktaufnahme</h2>
          <p>
            Im Fall der Kontaktaufnahme per E-Mail oder über das Kontaktformular
            werden die von Ihnen mitgeteilten Daten (insbes. Ihre
            E-Mail-Adresse, Ihr Name und ggf. Ihre Telefonnummer) zwecks
            Bearbeitung Ihrer Anfrage, für Anschlussfragen oder zur Abwicklung
            eines mit Ihnen bestehenden Vertrags gespeichert und verarbeitet
            (Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO). Die in diesem
            Zusammenhang anfallenden Daten werden gelöscht, nachdem die
            Speicherung nicht mehr erforderlich ist, oder ihre Verarbeitung wird
            eingeschränkt, falls gesetzliche Aufbewahrungspflichten bestehen.
            Eine Weitergabe an Dritte erfolgt in keinem Fall ohne Ihre
            Einwilligung.
          </p>
        </section>

        <section>
          <h2>Google Analytics</h2>
          <p>
            Diese Website benutzt Google Analytics, einen Webanalysedienst der
            Google Inc. („Google"). Google Analytics verwendet sog. „Cookies",
            die auf Ihrem Computer gespeichert werden und die eine Analyse der
            Benutzung der Website durch Sie ermöglichen. Die durch den Cookie
            erzeugten Informationen über Ihre Benutzung dieser Website werden in
            der Regel an einen Server von Google in den USA übertragen und dort
            gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf
            dieser Website, wird Ihre IP-Adresse von Google jedoch innerhalb von
            Mitgliedstaaten der Europäischen Union oder in anderen
            Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum
            zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an
            einen Server von Google in den USA übertragen und dort gekürzt. In
            unserem Auftrag wird Google diese Informationen nutzen, um Ihre
            Nutzung der Website auszuwerten, um anonymisierte Reports über die
            Websiteaktivitäten zusammenzustellen und um weitere mit der
            Website-Nutzung und der Internetnutzung verbundene Dienstleistungen
            gegenüber dem Website-Betreiber zu erbringen. Google nutzt die
            mittels Google Analytics gesammelte Daten auch zu eigenen Zwecken.
            Die im Rahmen von Google Analytics von Ihrem Browser übermittelte
            IP-Adresse wird jedoch nicht mit anderen Daten von Google
            zusammengeführt. Sie können die Speicherung der Cookies durch eine
            entsprechende Einstellung Ihrer Browser-Software verhindern; wir
            weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls
            nicht sämtliche Funktionen dieser Website vollumfänglich werden
            nutzen können.
          </p>
          <p>
            Sie können darüber hinaus die Erfassung der durch das Cookie
            erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl.
            Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten
            durch Google verhindern, indem Sie das unter dem folgenden Link
            verfügbare Browser-Plugin herunterladen und installieren:
            <br />
            <a
              href="https://tools.google.com/dlpage/gaoptout?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tools.google.com/dlpage/gaoptout?hl=de
            </a>
          </p>
          <p>
            Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden
            Sie unter den Google-Analytics-Bedingungen bzw. unter der
            Google-Analytics-Übersicht. Wir weisen Sie darauf hin, dass auf
            dieser Website Google Analytics um den Code „gat._anonymizeIp();"
            erweitert wurde, um eine anonymisierte Erfassung von IP-Adressen
            (sog. IP-Masking) zu gewährleisten. Um geeignete Garantien zur
            Einhaltung der in Kapitel V der DSGVO niedergelegten Bedingungen der
            Datenübermittlung und auch der sonstigen Bestimmungen der DSGVO zu
            bieten, verwendet Google entsprechende Art. 46 Abs. 2 lit. c DSGVO
            die von der EU-Kommission erlassenen Standarddatenschutzklauseln.
            Weitere Informationen darüber, welche Daten von Google erfasst
            werden, wofür diese Daten verwendet werden und welche Rechte Ihnen
            zustehen, finden Sie unter{" "}
            <a
              href="https://www.google.com/intl/de/policies/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.google.com/intl/de/policies/privacy/
            </a>
            .
          </p>
        </section>

        <section>
          <h2>Rechte betroffener Personen</h2>
          <p>
            Die Verarbeitung personenbezogener Daten, beispielsweise des Namens,
            der Anschrift, E-Mail-Adresse oder Telefonnummer einer betroffenen
            Person, erfolgt stets im Einklang mit der
            Datenschutz-Grundverordnung ((EU) 2016/679, vom 27.04.2016) und in
            Übereinstimmung mit den für stahlfaktor geltenden landesspezifischen
            Datenschutzbestimmungen.
          </p>
        </section>

        <section>
          <h2>Auskunftsrecht der betroffenen Person (Art. 15)</h2>
          <p>
            Sie können von dem Verantwortlichen eine Bestätigung darüber
            verlangen, ob personenbezogene Daten, die Sie betreffen, von diesem
            verarbeitet werden. Soweit dies der Fall ist, haben Sie das Recht
            auf Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
            Herkunft, Verarbeitungszweck und Empfänger oder Empfänger-Kategorien
            der personenbezogenen Daten, Dauer der Speicherung sowie Ihrer
            weiteren Rechte zu Berichtigung und Widerspruch.
          </p>
        </section>

        <section>
          <h2>Recht auf Berichtigung (Art. 16)</h2>
          <p>
            Sie haben das Recht von dem Verantwortlichen unverzüglich die
            Berichtigung sie betreffender unrichtiger personenbezogener Daten zu
            verlangen. Unter Berücksichtigung der Zwecke der Verarbeitung haben
            Sie weiterhin das Recht, die Vervollständigung unvollständiger
            personenbezogener Daten — auch mittels einer ergänzenden Erklärung —
            zu verlangen.
          </p>
        </section>

        <section>
          <h2>Recht auf Löschung (Art. 17)</h2>
          <p>
            Sie haben das Recht, von dem für die Verarbeitung Ihrer
            personenbezogenen Daten Verantwortlichen zu verlangen, dass die Sie
            betreffenden personenbezogenen Daten unverzüglich gelöscht werden.
            Die Löschung muss jedoch tatsächlich nur vorgenommen werden, sofern
            einer der folgenden Gründe zutrifft:
          </p>
          <ul>
            <li>
              Die personenbezogenen Daten wurden für solche Zwecke erhoben oder
              auf sonstige Weise verarbeitet, für welche sie nicht mehr
              notwendig sind.
            </li>
            <li>
              Die betroffene Person widerruft ihre Einwilligung, auf die sich
              die Verarbeitung stützte, und es fehlt an einer anderweitigen
              Rechtsgrundlage für die Verarbeitung.
            </li>
            <li>
              Die personenbezogenen Daten wurden unrechtmäßig verarbeitet.
            </li>
            <li>
              Die Löschung der personenbezogenen Daten ist zur Erfüllung einer
              rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der
              Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt.
            </li>
          </ul>
        </section>

        <section>
          <h2>Recht auf Einschränkung der Verarbeitung (Art. 18)</h2>
          <p>
            Unter den folgenden Voraussetzungen können Sie die Einschränkung der
            Verarbeitung der Sie betreffenden personenbezogenen Daten verlangen:
          </p>
          <ul>
            <li>
              wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen
              für eine Dauer bestreiten, die es dem Verantwortlichen ermöglicht,
              die Richtigkeit der personenbezogenen Daten zu überprüfen;
            </li>
            <li>
              die Verarbeitung unrechtmäßig ist und Sie die Löschung der
              personenbezogenen Daten ablehnen und stattdessen die Einschränkung
              der Nutzung der personenbezogenen Daten verlangen;
            </li>
            <li>
              der Verantwortliche die personenbezogenen Daten für die Zwecke der
              Verarbeitung nicht länger benötigt, Sie diese jedoch zur
              Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen
              benötigen, oder
            </li>
            <li>
              wenn Sie Widerspruch gegen die Verarbeitung eingelegt haben und
              noch nicht feststeht, ob die berechtigten Gründe des
              Verantwortlichen gegenüber Ihren Gründen überwiegen.
            </li>
          </ul>
        </section>

        <section>
          <h2>Recht auf Datenübertragbarkeit (Art. 20)</h2>
          <p>
            Sie haben das Recht, die Sie betreffenden personenbezogenen Daten,
            die Sie dem Verantwortlichen bereitgestellt haben, in einem
            strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
            Außerdem haben Sie das Recht diese Daten einem anderen
            Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem
            die personenbezogenen Daten bereitgestellt wurden, zu übermitteln.
          </p>
        </section>

        <section>
          <h2>Recht auf Widerspruch (Art. 21)</h2>
          <p>
            Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
            Situation ergeben, jederzeit gegen die Verarbeitung der Sie
            betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1
            lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch
            für ein auf diese Bestimmungen gestütztes Profiling. Der
            Verantwortliche verarbeitet die Sie betreffenden personenbezogenen
            Daten nach Ausübung Ihres Widerspruchsrechts nicht mehr, es sei
            denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung
            nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen,
            oder die Verarbeitung dient der Geltendmachung, Ausübung oder
            Verteidigung von Rechtsansprüchen.
          </p>
        </section>

        <section>
          <h2>
            Automatisierte Entscheidungen einschließlich Profiling (Art. 22)
          </h2>
          <p>
            Jede von der Verarbeitung personenbezogener Daten betroffene Person
            hat das Recht, nicht einer ausschließlich auf einer automatisierten
            Verarbeitung — einschließlich Profiling — beruhenden Entscheidung
            unterworfen zu werden, die ihr gegenüber rechtliche Wirkung
            entfaltet oder sie in ähnlicher Weise erheblich beeinträchtigt,
            sofern die Entscheidung (1) nicht für den Abschluss oder die
            Erfüllung eines Vertrags zwischen der betroffenen Person und dem
            Verantwortlichen erforderlich ist, oder (2) aufgrund von
            Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der
            Verantwortliche unterliegt, zulässig ist und diese
            Rechtsvorschriften angemessene Maßnahmen zur Wahrung der Rechte und
            Freiheiten sowie der berechtigten Interessen der betroffenen Person
            enthalten oder (3) mit ausdrücklicher Einwilligung der betroffenen
            Person erfolgt. Ist die Entscheidung (1) für den Abschluss oder die
            Erfüllung eines Vertrags zwischen der betroffenen Person und dem
            Verantwortlichen erforderlich oder (2) erfolgt sie mit
            ausdrücklicher Einwilligung der betroffenen Person, trifft
            stahlfaktor angemessene Maßnahmen, um die Rechte und Freiheiten
            sowie die berechtigten Interessen der betroffenen Person zu wahren,
            wozu mindestens das Recht auf Erwirkung des Eingreifens einer Person
            seitens des Verantwortlichen, auf Darlegung des eigenen Standpunkts
            und auf Anfechtung der Entscheidung gehört.
          </p>
        </section>

        <section>
          <h2>
            Recht auf Widerruf der datenschutzrechtlichen Einwilligung (Art. 7
            Abs. 3)
          </h2>
          <p>
            Sie haben das Recht, uns von Ihnen erteilte Einwilligungserklärungen
            zur Verarbeitung Ihrer personenbezogenen Daten jederzeit zu
            widerrufen. Ihren Widerruf richten Sie bitte per E-Mail an
            info@stahlfaktor.de
          </p>
        </section>

        <section>
          <h2>Recht auf Beschwerde bei einer Aufsichtsbehörde (Art. 77)</h2>
          <p>
            Jede betroffene Person hat unbeschadet eines anderweitigen
            verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs das Recht
            auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
            Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des
            Orts des mutmaßlichen Verstoßes, wenn die betroffene Person der
            Ansicht ist, dass die Verarbeitung der sie betreffenden
            personenbezogenen Daten gegen diese Verordnung verstößt. Die
            Anschrift der für den Verantwortlichen zuständigen Aufsichtsbehörde
            lautet:
          </p>
          <p>
            Landesbeauftragte für Datenschutz und Informationsfreiheit
            <br />
            Nordrhein-Westfalen
            <br />
            Postfach 20 04 44
            <br />
            40102 Düsseldorf
          </p>
          <p>
            Tel.: 0211 38424-0
            <br />
            Fax: 0211 38424-999
            <br />
            E-Mail: poststelle@ldi.nrw.de
          </p>
        </section>

        <section>
          <h2>Name und Anschrift des für die Verarbeitung Verantwortlichen</h2>
          <p>
            Verantwortlicher gem. Art. 4 Abs. 7 EU-Datenschutz-Grundverordnung
            (DSGVO), sonstiger in den Mitgliedstaaten der Europäischen Union
            geltenden Datenschutzgesetze und anderer Bestimmungen mit
            datenschutzrechtlichem Charakter ist:
          </p>
          <p>
            stahlfaktor
            <br />
            Neuenlander Str. 24
            <br />
            58256 Ennepetal
          </p>
          <p>
            Melanie Brücher-Kümmel
            <br />
            Geschäftsführerin
          </p>
          <p>
            Tel.: 02333/616101
            <br />
            E-Mail: info@stahlfaktor.de
          </p>
        </section>
      </div>
    </div>
  );
}
